import { DateTime } from 'luxon';
import EventDTO from '../models/event';

// Los eventos siempre son hora argentina (ver utils/dates.ts).
const AR_TIMEZONE = 'America/Argentina/Buenos_Aires';

/**
 * Mensaje que acompaña el link de las entradas en la venta simplificada.
 *
 * `text` va sin el link (navigator.share lo agrega solo a partir de `url`).
 * `message` es el texto completo con el link al final, para copiar y pegar.
 * El link va último para que WhatsApp arme la vista previa y el mensaje
 * se lea primero.
 */
export default function buildTicketShareMessage(
  event: Pick<EventDTO, 'name' | 'date' | 'place' | 'has_showtimes' | 'showtimes'> | null | undefined,
  orderUrl: string,
  showtimeId?: string | null,
): { text: string; message: string } {
  const name = event?.name?.trim() || 'el evento';

  const showtime = showtimeId ? event?.showtimes?.find((s) => s.id === showtimeId) : undefined;
  // Con funciones, la fecha sale de la función elegida. Si no se encuentra,
  // no se pone fecha: mejor ninguna que una equivocada (igual que la imagen).
  const iso = showtime?.starts_at ?? (event?.has_showtimes ? undefined : event?.date);
  const dt = iso ? DateTime.fromISO(iso, { zone: AR_TIMEZONE }).setLocale('es') : null;

  const lines: string[] = [`¡Hola! Te envío tus entradas para *${name}*.`];

  const details: string[] = [];
  if (dt?.isValid) {
    const day = dt.toFormat("cccc d 'de' LLLL");
    details.push(`${day.charAt(0).toUpperCase()}${day.slice(1)}, ${dt.toFormat('HH:mm')} hs`);
  }
  if (event?.place?.trim()) {
    details.push(event.place.trim());
  }
  if (details.length > 0) {
    lines.push('', ...details);
  }

  lines.push('', 'Abrí el link y mostrá el QR en la entrada:');

  const text = lines.join('\n');
  return { text, message: `${text}\n${orderUrl}` };
}
